// extracted by mini-css-extract-plugin
export default {"home":"Home_home__rZ71k","homePageText":"Home_homePageText__VXlxw","css-dljw17":"Home_css-dljw17__PWT23"};